import { Component, Input } from '@angular/core';
@Component({
  selector: 'hospitable-page-level-error',
  templateUrl: './page-level-error.component.html',
  styleUrls: ['./page-level-error.component.scss'],
})
export class PageLevelErrorComponent {
  @Input() message: string = `Oops, an error has occurred`;
}
